export default "__VITE_ASSET__CBc9XhJB__"